import { atom } from "recoil";

export default atom({
  key: "header",
  default: {
    title: null
  }
});
